import filterService from '@/services/filter.service';
import { httpClient } from "@/services";

export default {
	state: {
		autocompleteList: null,
		filterTruck: null,
		filterTrailer: null,
		filterTrailerType: null,
		filterDriver: null,
		filterCustomer: null,
		filterBrocker: null,
		filterBrockerNum: null,
		filterDispatcher: null,
		filterBilling: null,
		selectBol: null,
		selectInvoiced: null,
		filtersVal: {
			selectTruck: [],
			selectTrailer: [],
			selectTrailerType: [],
			selectDriver: [],
			selectCustomer: [],
			selectBrocker: [],
			selectBrockerNum: [],
			selectId: [],
			selectDispatcher: [],
			dateDelivery: [],
			datePU: [],
			selectBilling: [],
			selectBol: [],
			selectInvoiced: [],
			limit: 15,
			pageNum: 1
		},
		brockerList: [],
		order: null,
		sort: null,
		filterChecked: false
	},
	mutations: {
		SET_FILTER_CHECKED(state, payload) {
			state.filterChecked = payload;
		},
		REFRESH(state) {
			state.autocompleteList = null;
			state.filterTruck = null;
			state.filterTrailer = null;
			state.filterTrailerType = null;
			state.filterDriver = null;
			state.filterCustomer = null;
			state.filterBrocker = null;
			state.filterBrockerNum = null;
			state.filterDispatcher = null;
			state.filterBilling = null,
			  state.selectBol = null,
			  state.selectInvoiced = null,
			  state.filtersVal = {
				  selectTruck: [],
				  selectTrailer: [],
				  selectTrailerType: [],
				  selectDriver: [],
				  selectCustomer: [],
				  selectBrocker: [],
				  selectBrockerNum: [],
				  selectId: [],
				  selectDispatcher: [],
				  dateDelivery: [],
				  datePU: [],
				  selectedBilling: [],
				  selectBol: [],
				  selectInvoiced: [],
				  weeks: 4,
				  limit: 15,
				  pageNum: 1
			  };
			state.brockerList = [];
			state.order = null;
			state.sort = null;
		},
		SET_ORDER(state, payload) {
			state.order = payload;
		},
		SET_SORT(state, payload) {
			state.sort = payload;
		},
		SET_AUTOCOMPLETE(state, payload) {
			state.autocompleteList = payload;
			state.filterTruck = payload.filterTruck;
			state.filterTrailer = payload.filterTrailer;
			state.filterTrailerType = payload.filterTrailerType;
			state.filterDriver = payload.filterDriver;
			state.filterCustomer = payload.filterCustomer;
			state.filterBrocker = payload.filterBrocker;
			state.filterBrockerNum = payload.filterBrockerNum;
			state.filterBilling = payload.filterBilling;
			state.selectBol = payload.selectBol;
			state.selectInvoiced = payload.selectInvoiced;
			state.filterTrip = [];
			state.filterLoad = [];
			state.filterDispatcher = payload.filterDispatcher;
		},
		SET_FILTERS(state, payload) {
			payload.order = state.order;
			payload.sort = state.sort;
			state.filtersVal = payload;
		},
		SET_BROCKER(state, payload) {
			state.brockerList = payload.filterBrockers;
		}
	},
	getters: {
		checkRefreshFilters(state) {
			return state.filterChecked;
		},
		getOrder(state) {
			return state.order;
		},
		getSort(state) {
			return state.sort;
		},
		getFiltersVal(state) {
			return state.filtersVal;
		},
		getAutocompleteList(state) {
			return state.autocompleteList;
		},
		getBrockerList(state) {
			return state.brockerList;
		}
	},
	actions: {
		refreshFilters({ commit }) {
			commit('REFRESH');
		},
		async getAutocompleteList({ commit }, payload) {
			try {
				const data = await filterService.getAutoList(payload).then(resp => resp).catch(error => error);
				commit('SET_AUTOCOMPLETE', data);
				return data;
			} catch (error) {
				return error;
			}
		},
		setOrder({ commit }, payload) {
			commit('SET_ORDER', payload);
		},
		setSort({ commit }, payload) {
			commit('SET_SORT', payload);
		},
		setFilters({ commit }, payload) {
			commit('SET_FILTERS', payload);
		},
		async getStates(context, payload) {
			return await filterService.getStates(payload).then(resp => resp.states).catch(error => error);
		},

		async getBrocker({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post(`/filterBrockers`);
				dispatch("actionPreloader", false);
				commit('SET_BROCKER', data);
				return data;
			} catch (e) {
				console.error(e);
			}
		},
	}
};
